import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpHelper } from '../helpers/http-helper';
import { AuthenticationService } from './authentication.service';
import { SettingsService } from './settings.service';
import { StorageManagerService } from './storage-manager.service';
import { IApiResult } from '../models/api-result';
import { IServerSettings } from '../models';
import { INavdlContact } from '../models/navdl-contact';
@Injectable()
export class NavDLService {
  httpHelper: HttpHelper;
  settings: IServerSettings;
  action: string;
  apiUrl: string;

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService,
    private authService: AuthenticationService,
    private storageManagerService: StorageManagerService
  ) {
    this.httpHelper = new HttpHelper(http, authService, storageManagerService);
  }

  sendNavDLContactMessage(contactForm: INavdlContact) {
    let headers = this.httpHelper.createHttpHeaders();
    const modifiedByUser = this.settingsService.getUserDataName();
    this.settings = this.settingsService.getSettings();
    this.apiUrl = this.settings.ApiGatewayUrl;
    this.action = 'ssdpds/v1/NavDl/Contact';
    headers = headers.set('modifiedByUser', modifiedByUser);

    return this.http
      .post(`${this.apiUrl}/${this.action}`, contactForm, { headers: headers })
      .pipe(map(this.extractData), catchError(this.handleErrors));
  }

  private extractData(response: any) {
    if (response.status < 200 || response.status >= 300) {
      throw new Error('Bad response status: ' + response.status);
    }
    const body = response as IApiResult;
    return body;
  }

  // Error handling
  private handleErrors(error: any): Observable<any> {
    const GENERIC_ERROR_MSG =
      'It looks like something went wrong. Try reloading the page or contacting support if this issue continues.';
    const bDisplayDetailMsg =
      error && error.error && error.error.isBusinessErrorMessage
        ? true
        : !!isDevMode();
    error.error =
      error && error.error && error.error.message && bDisplayDetailMsg
        ? error.error.message
        : GENERIC_ERROR_MSG;

    return throwError(() => error.error);
  }
}
